module.exports = __webpack_public_path__ + "img/axle_conf_2.5bd02ce8.jpg";